var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCsv(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.943,
    height: 90.553,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-462.5 -313.5)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 69",
    transform: "translate(5 -3)",
    fill: "none",
    stroke: "#5300f2",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 46",
    width: 65.758,
    height: 87.553,
    rx: 6,
    transform: "translate(459 318)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 6",
    strokeLinecap: "round",
    d: "M470.508 332.385h42.743"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 7",
    strokeLinecap: "round",
    d: "M470.508 348.824h42.743"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8",
    strokeLinecap: "round",
    d: "M470.508 382.824h42.743"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 9",
    strokeLinecap: "round",
    d: "M470.508 390.824h42.743"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 10",
    strokeLinecap: "round",
    d: "M470.508 340.604h42.743"
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 47",
    width: 53,
    height: 20,
    rx: 3,
    transform: "translate(484.443 353.277)",
    fill: "#5300f2"
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": ".CSV",
    transform: "translate(498.443 367.277)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "SegoeUI-Semibold, Segoe UI",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, ".CSV")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.d241607fa4432f16a5c5a0cb0924025a.svg";
export { ForwardRef as ReactComponent };